import React from 'react'
import axios from 'axios';
import { API_KEY } from '../constants';
import Card from './Card'
import { useDispatch, useSelector } from "react-redux";
import { setDataDisponibles } from "../store/data/dataSlice";

function Cards({ setFooterData }) {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.data.webpage);
  const [cards, setCards] = React.useState([])


  React.useEffect(() => {
    let sheet = "DISPONIBLES"
    axios.get(`https://sheets.googleapis.com/v4/spreadsheets/1FyBkFmdLO8BeNdmDohYRvAh_nJP1jsdsEZ_rPYm8m1s/values/${sheet}?key=${API_KEY}`)
      .then(res => {
        const data = res.data.values;
        const filteredData = data.filter(item => item[0] !== 'No')
        
        // Extraer datos del footer (donde item[1] === 'FOOTER')
        const footerData = data.filter(item => item[1] === 'FOOTER');
        console.log('footerData', footerData);
        setFooterData(footerData);
        
        // Filtrar datos que NO son footer para las cards
        const cardsData = filteredData
        cardsData.shift();
        
        setCards(cardsData);
        dispatch(setDataDisponibles(cardsData));
      })
  }, [dispatch, setFooterData])

  return (

    <div className='container'>
      <div className='row-cards'>
        {
          cards.map((casa, index) =>
            <Card key={index} props={{ casa: casa, content: data }} />)
        }
      </div>
    </div>
  )
}

export default Cards